import InternalTransportBaseScreen from "../../shared/internalTransport/InternalTransportBaseScreen";

export const InternalTransportBase = ({ modalData }: { modalData: any }) => (
  <InternalTransportBaseScreen modalData={modalData} gate="farm" variant="mapping" />
);
